import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import * as _ from 'lodash-es';
import { FlowType } from 'src/app/models/proofreading.model';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

export interface ListItemDialogOptions {
    title: string;
    text: string;
    valid: string;
    items: string[];
    cancel?: boolean;
}


@Component({
    selector: 'app-list-item-dialog',
    templateUrl: './list-item-dialog.component.html',
    styleUrls: ['./list-item-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslatePipe]
})
export class ListItemDialogComponent {
    dialogRef = inject<MatDialogRef<ListItemDialogComponent>>(MatDialogRef);
    data = inject<ListItemDialogOptions>(MAT_DIALOG_DATA);

    protected _defaultCtx: ListItemDialogOptions = {
        title: '',
        text: '',
        items: [],
        valid: 'YES',
    };

    completed: string[] = [];
    incompleted: string[] = [];

    public ctx: ListItemDialogOptions;

    constructor() {
        this.ctx = _.merge(this._defaultCtx, _.cloneDeep(this.data));
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
